import { Delete } from "@mui/icons-material";

export const deleteIcon = (props) => {
  return <Delete {...props} />;
};
